
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('ProjectSubmission', function ($log, Parse, ProjectSchema, ProjectSectionSchema, ProjectRewardSchema, MediaSchema) {

		/**
		 * Submits a new project for approval and review by the team
		 */
		this.submit = async data => {

			// $log.log(data)

			let project = new ProjectSchema();

			project.set('title', data.title);
			project.set('description', data.description);
			project.set('city', data.city);
			project.set('postal_code', data.postal_code);
			project.set('country', data.country);
			project.set('start_date', data.start_date);
			project.set('end_date', data.end_date);
			project.set('allow_pledge_rewards', data.allow_pledge_rewards);

			// Clean goal amounts
			if (data.investment_goal_min) project.set('investment_goal_min', parseInt(data.investment_goal_min.replace(/[^0-9]+/g, '')));
			if (data.investment_goal_max) project.set('investment_goal_max', parseInt(data.investment_goal_max.replace(/[^0-9]+/g, '')));

			let rewardRelation = project.relation('pledge_rewards');

			// Clean reward amounts if using rewards
			if (data.allow_pledge_rewards) {
				for (let reward of data.rewards) {

					reward = await (new ProjectRewardSchema({
						title: reward.title,
						amount: parseInt(reward.amount.replace(/[^0-9]+/g, '')),
						description: reward.description
					})).save();

					// Add the reward to the project relation
					rewardRelation.add(reward);

				}
			}

			let sectionRelation = project.relation('sections');

			for (let section of data.sections) {

				section = await (new ProjectSectionSchema({
					title: section.title,
					body: section.body,
					order: section.order,
					default: section.default
				})).save();

				// Add the section to the project relation
				sectionRelation.add(section);

			}

			// Upload the project image
			if (typeof data.header_media !== 'undefined') {

				// Sanitize the filename
				let filename = data.header_media.name.split('.');
				let ext = filename.pop();
				filename = filename.join('_').replace(/[^a-z0-9]/gi, '_').toLowerCase();
				filename = `${filename}.${ext}`;

				// Create a Parse File and save it
				let parseFile = new Parse.File(filename, data.header_media, data.header_media.type);

				// Save the project image
				$log.log('Uploading project image:', filename);
				await parseFile.save();

				let headerMedia = new MediaSchema({
					file: parseFile,
					type: 'img'
				});
				await headerMedia.save();

				// Set project image and save
				project.set('header_media', headerMedia);

			}

			$log.log(project);

			$log.log('Saving project:', project.title);
			return project.save();

		}

	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/project-submission.service.js